import React from 'react';
import { MenuItemArgs } from './types';
import { IconRemoveUser, IconClear, IconAceptUser, IconInvite } from './icons';
import { Poppins } from 'src/common';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';
import * as S from './util.styles';

export const MAKE_ADMIN = ({ label, exe, divider, resetActiveItem, setActiveItem }: MenuItemArgs) => (
  <div key="make-admin">
    <S.ItemSingleCol
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:MakeAdmin',
        });
      }}
      onMouseEnter={() => setActiveItem('make-admin')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-make-admin"
    >
      <Poppins px={16}>{label || 'Make Admin'}</Poppins>
    </S.ItemSingleCol>
    {divider && <div className="divider" />}
  </div>
);

export const REMOVE_USER = ({ label, exe, divider, resetActiveItem, setActiveItem }: MenuItemArgs) => (
  <div key="remove-user">
    <S.ItemSingleCol
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:RemoveUser',
        });
      }}
      onMouseEnter={() => setActiveItem('remove-user')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-remove-user"
    >
      <Poppins px={16}>{label || 'Remove user'}</Poppins>
    </S.ItemSingleCol>
    {divider && <div className="divider" />}
  </div>
);

export const REMOVE_PERSON = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="remove-person">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:RemovePerson',
        });
      }}
      onMouseEnter={() => setActiveItem('remove-person')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-remove-person"
    >
      <div className="icon-container">
        <IconRemoveUser isActive={activeItem === 'remove-person'} />
      </div>
      <Poppins px={16}>{label || 'Remove Person'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const ACCEPT_USER = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="accept-user">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:AcceptUser',
        });
      }}
      onMouseEnter={() => setActiveItem('accept-user')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-accept-user"
    >
      <div className="icon-container">
        <IconAceptUser isActive={activeItem === 'accept-user'} />
      </div>
      <Poppins px={16}>{label || 'Accept user'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const REJECT_USER = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="reject-user">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:RejectUser',
        });
      }}
      onMouseEnter={() => setActiveItem('reject-user')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-reject-user"
    >
      <div className="icon-container">
        <IconClear isActive={activeItem === 'reject-user'} />
      </div>
      <Poppins px={16}>{label || 'Reject user'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const CANCEL_INVITE = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="cancel-invite">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:CancelInvite',
        });
      }}
      onMouseEnter={() => setActiveItem('cancel-invite')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-cancel-invite"
    >
      <div className="icon-container">
        <IconClear isActive={activeItem === 'cancel-invite'} />
      </div>
      <Poppins px={16}>{label || 'Cancel invite'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const INVITE = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="invite">
    <S.Item
      onClick={exe}
      onMouseEnter={() => setActiveItem('invite')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-invite"
    >
      <div className="icon-container">
        <IconInvite isActive={activeItem === 'invite'} />
      </div>
      <Poppins px={16}>{label || 'Invite'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const GRANT_ACCESS = ({ label, exe, divider, resetActiveItem, activeItem, setActiveItem }: MenuItemArgs) => (
  <div key="grant-access">
    <S.Item
      onClick={(e) => {
        exe(e);
        mpEvent(MPEvents.ButtonClick, {
          button: 'Elipsis:GrantAccess',
        });
      }}
      onMouseEnter={() => setActiveItem('grant-access')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-grant-access"
    >
      <div className="icon-container">
        <IconInvite isActive={activeItem === 'grant-access'} />
      </div>
      <Poppins px={16}>{label || 'Grant access'}</Poppins>
    </S.Item>
    {divider && <div className="divider" />}
  </div>
);

export const CHANGE_PERMISSIONS = ({ label, exe, divider, resetActiveItem, setActiveItem }: MenuItemArgs) => (
  <div key="change-permissions">
    <S.ItemSingleCol
      onClick={exe}
      onMouseEnter={() => setActiveItem('change-permissions')}
      onMouseLeave={resetActiveItem}
      data-cy="common-menu-change-permissions"
    >
      <Poppins px={16}>{label || 'Change permissions'}</Poppins>
    </S.ItemSingleCol>
    {divider && <div className="divider" />}
  </div>
);
